var render = function render(){var _vm=this,_c=_vm._self._c;return _c('historical-bookings')
}
var staticRenderFns = []

export { render, staticRenderFns }